import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useSubscription } from '../hooks/useSubscription'
import { Button } from '../components/ui/Button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card'
import { PageLayout } from '../components/layout/PageLayout'
import { LatestBlogPosts } from '../components/blog/LatestBlogPosts'

export function Home() {
  const { user } = useAuth()
  const { subscription, getActivePlan, isActive } = useSubscription()

  return (
    <PageLayout>
      <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 sm:text-6xl">
              Social Pack Generator V1.4
            </h1>
            <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
              Create stunning social media content with our AI-powered generator.
              Perfect for Realtors, Mortgage Brokers and other Marketing Professionals.
            </p>
            
            {user ? (
              <div className="mt-10">
                {isActive() ? (
                  <div className="space-y-4">
                    <p className="text-lg text-throttle-cyan-600 font-medium">
                      Welcome back! You have access to {getActivePlan()}
                    </p>
                    <Link to="/generator">
                      <Button size="lg">
                        Start Creating
                      </Button>
                    </Link>
                  </div>
                ) : (
                  <div className="space-y-4">
                    <p className="text-lg text-gray-600">
                      Get started by choosing a plan
                    </p>
                    <Link to="/pricing">
                      <Button size="lg">
                        View Pricing
                      </Button>
                    </Link>
                  </div>
                )}
              </div>
            ) : (
              <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/signup">
                  <Button size="lg">
                    Get Started Free
                  </Button>
                </Link>
                <Link to="/pricing">
                  <Button variant="outline" size="lg">
                    View Pricing
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Latest Blog Posts Section */}
      <LatestBlogPosts />

      {/* Features Section */}
      <div className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">
              Everything you need to create amazing content
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card>
              <CardHeader>
                <CardTitle>AI-Powered Generation</CardTitle>
                <CardDescription>
                  Create professional social media content using advanced AI technology
                </CardDescription>
              </CardHeader>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Multiple Formats</CardTitle>
                <CardDescription>
                  Generate content for Instagram, Facebook, Twitter, LinkedIn, and more
                </CardDescription>
              </CardHeader>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Easy to Use</CardTitle>
                <CardDescription>
                  Simple interface that gets you from idea to published content in minutes
                </CardDescription>
              </CardHeader>
            </Card>
          </div>
        </div>
      </div>
      </div>
    </PageLayout>
  )
}